import { atom } from 'recoil'

const userDetailsState = atom({
  key: 'userDetails',
  default: {},
})

export { userDetailsState }
